import { atom } from "jotai";

import { UiDictionaryKey } from "@plansoft-configuration-renderer/localization";

export interface GlobalErrorEvent {
  /** Monotonically increasing id so the same key/message can retrigger a toast. */
  id: number;
  /** Fully-namespaced translation key, e.g. "CustomApp:someKey". Omitted when only a fallback message is available. */
  key?: UiDictionaryKey;
  params?: Record<string, unknown>;
  fallbackMessage?: string;
}

/**
 * Latest backend error that should surface as a snackbar. `GlobalErrorNotifier`
 * watches this and shows a toast via `useUiTranslator()`.
 */
export const globalErrorEventAtom = atom<GlobalErrorEvent | null>(null);
